import { registerTicketView } from "@shared/components/tickets/ticketViewRegistry";
import MaintenanceTicketView from "./components/MaintenanceTicketView.vue";

registerTicketView({
  twinTypePattern: "tm.ticket.*",
  component: MaintenanceTicketView,
});
